import React from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../../components/SideBar";
import NavBar from "../../components/NavBar";

const DashboardLayout = () => {
  return (
    <section className=" flex h-screen bg-neutral200 lg:pr-3">
      <section className=" duration-300  hidden lg:flex">
        <SideBar />
      </section>

      <section className="w-full relative overflow-y-auto lg:my-4 rounded-xl border border-neutral200  bg-neutral200 ">
        <div className=" lg:hidden">
          <NavBar />
        </div>

        <div className="bg-white h-full">
          <Outlet />
        </div>
      </section>
    </section>
  );
};

export default DashboardLayout;
